import { useQuery } from '@tanstack/react-query';
import { fetchNotifications } from '../data/query.js';
import { useMenuAxios } from '../context/axios.js';

const useNotificationsQuery = () => {
  const {
    instance
  } = useMenuAxios();
  return useQuery({
    queryKey: ["notifications"],
    queryFn: () => fetchNotifications(instance),
    enabled: false
  });
};

export { useNotificationsQuery };
